var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContent)?_c('span',{staticClass:"d-inline-block"},[(_vm.prefix)?[_vm._v(_vm._s(_vm.prefix))]:_vm._e(),_vm._v(" "),(_vm.content)?[_vm._v(_vm._s(_vm.content))]:_vm._e(),_vm._v(" "),(_vm.suffix)?[_vm._v(_vm._s(_vm.suffix))]:_vm._e()],2):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba7c7bbe","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/LocaleText.vue
// module id = 1397
// module chunks = 1